import { Component } from 'react'
import { Sortings, Sorting } from 'stylewhere/api'
import { OperationList, SortingRow } from 'stylewhere/components'
import { Routes } from 'stylewhere/pages'
import { RemoteOperation, Router, SortingOperationConfig } from 'stylewhere/shared'

interface State {
  sortings?: Sorting[]
}

interface SortingListProps {
  match: { params: { opCode: string } }
}

export default class SortingList extends Component<SortingListProps, State> {
  state: State = {
    sortings: undefined
  }
  get opCode() {
    return this.props.match.params.opCode
  }
  submitPath: Routes = '/sorting/:opCode/start/:code'
  operation = RemoteOperation.getOperationConfig<SortingOperationConfig>(this.opCode)

  componentDidMount() {
    this._init()
  }

  _init = async () => {
    await this.updateSortings()
  }

  onRowClick = (sorting: Sorting) => {
    Router.navigate(
      '/sorting/:opCode/reading',
      { opCode: this.opCode },
      {
        state: {
          formData: {
            sortingId: sorting.id,
            originZoneId: this.operation.enableOriginZone && sorting.originZoneId ? sorting.originZoneId : undefined
          }
        }
      }
    )
  }

  updateSortings = async (search?: string) => {
    let sortings: Sorting[] = []
    try {
      sortings = (
        await Sortings.search<Sorting>({
          operationIds: this.operation.id,
          statuses: ['OPEN', 'CONFIRM_ERROR'],
          search
        })
      ).content
    } catch {}

    this.setState({ sortings })
  }

  sortingRender = (sorting: Sorting) => {
    return <SortingRow sorting={sorting} onClick={() => this.onRowClick(sorting)} />
  }

  render() {
    const { sortings } = this.state
    return (
      <OperationList
        onChangeSearch={this.updateSortings}
        data={sortings}
        customRowRender={this.sortingRender}
        operation={this.operation}
        submitPath={this.submitPath}
        hideNewButton={!this.operation.showCreateButton}
      />
    )
  }
}
